import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDownloadables } from "../slice/workerDownloadSlice";

const WorkerDownload = () => {
  const dispatch = useDispatch();

  const { downloadData, loading, error } = useSelector(
    (state) => state.workerDownload
  );

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (!token) return;
    dispatch(getDownloadables(token));
  }, [token, dispatch]);

  // Handle download dynamically per file
  const handleDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = downloadUrl;
      link.download = fileName || "download";

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
      <div className="ps-2 ps-lg-4">
        <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
          Download
        </h4>

        {/* LOADING */}
        {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>}

        {/* ERROR */}
        {error && <p className="text-danger">{error}</p>}

        {!loading && !error && (
          <div className="row g-3">
            {downloadData.length === 0 ? (
              <div className="text-center py-5">
                <h5 className="text-muted">No Downloads Available</h5>
              </div>
            ) : (
              downloadData.map((down, index) => (
                <div class="download-data-box" key={index}>
                  <h5 class="download-catname">{down.category}</h5>
                  <div className="row">
                    <div className="">
                      <ul className="dlm-downloads">
                        {down.files.map((file) => (
                          <li key={file.id}>
                            <div className="download-item-box">
                              {file.file.match(/\.(jpg|jpeg|png|gif)$/i) && (
                                <i className="fa fa-file-image-o" style={{
                                  marginRight: "8px",
                                  color: "#0073aa",
                                  fontSize: "90px",
                                  marginBottom: "10px",
                                }}
                                ></i>
                              )}

                              {file.file.match(/\.(docx|doc|docx)$/i) && (
                                <i className="fa fa-file-word-o" style={{
                                  marginRight: "8px",
                                  color: "#0073aa",
                                  fontSize: "90px",
                                  marginBottom: "10px",
                                }}
                                ></i>
                              )}

                              {file.file.match(/\.(pdf)$/i) && (
                                <i className="fa fa-file-pdf-o" style={{
                                  marginRight: "8px",
                                  color: "#0073aa",
                                  fontSize: "90px",
                                  marginBottom: "10px",
                                }}
                                ></i>
                              )}

                              {file.file.match(/\.(zip)$/i) && (
                                <i className="fa fa-file-archive-o" style={{
                                  marginRight: "8px",
                                  color: "#0073aa",
                                  fontSize: "90px",
                                  marginBottom: "10px",
                                }}
                                ></i>
                              )}

                              {file.file.match(/\.(mp3|wav|ogg)$/i) && (
                                <i className="fa fa-file-audio-o" style={{
                                  marginRight: "8px",
                                  color: "#0073aa",
                                  fontSize: "90px",
                                  marginBottom: "10px",
                                }}
                                ></i>
                              )}

                              {file.file.match(/\.(mp4|webm)$/i) && (
                                <i className="fa fa-file-video-o" style={{
                                  marginRight: "8px",
                                  color: "#0073aa",
                                  fontSize: "90px",
                                  marginBottom: "10px",
                                }}
                                ></i>
                              )}

                              <div className="download-file">
                                {file.title.split("/").pop()}
                              </div>

                              <div className="btn-custom-primary">

                                <button
                                  className="btn download-link btn-light-header"
                                  onClick={() => handleDownload(file.file, file.file.split("/").pop())}

                                >
                                  Download
                                </button>

                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkerDownload;
